import { Component } from "@angular/core";
import { ApiRequestDto, ApiRequestDtoListLiteralCategory, ReportsService} from "../../api";
import { FacilitiesService } from "../../core";
import { DownloadFileContentModal } from "../download-file-content/download-file-content-modal.component";
import { LiteralCategory } from "../../api/model/literalCategory";
import { LoadingError, ErrorObjectTypeEnum } from "../../core/error-catching.service";
import { takeUntil, catchError } from 'rxjs/operators';

@Component({
    selector: 'my-resident-literal-order-modal',
    templateUrl: 'resident-literal-order.component.html',
    styleUrls: ['resident-literal-order.component.scss']
})
export class ResidentLiteralOrderModal extends DownloadFileContentModal {

    constructor( private reportService: ReportsService,
                 private facilityService: FacilitiesService){
        super();
    }    

    reportName: string = "Resident Literal Orders";    
    title: string = "Download Resident Literal Orders";    
    searchText: string;
    filteredLiteralCategory: LiteralCategory[]=[];
    allLiteralCategories: LiteralCategory[]=[];
    selectedLiteralCategory: LiteralCategory[]=[];

    isLoadingLiteralCategory: boolean=false;
    hideSpinner: boolean = true;
    areAllCategorySelected: boolean = true;
    
    show() {
        this.hideSpinner = true;
        this.allLiteralCategories = null;
        this.filteredLiteralCategory = null;
        this.isLoadingLiteralCategory = true;         
        const requestParams: ApiRequestDto = { 
            OrgList: this.facilityService.selectedAsOrgList,
        };
        this.reportService.reportsGetLiteralCategories(requestParams)
            .pipe(takeUntil(this.stop$)).subscribe((result) => {          
              
                this.filteredLiteralCategory = result;
                this.allLiteralCategories = result;                
                Object.assign(this.selectedLiteralCategory, result);
                this.isLoadingLiteralCategory = false;                
        });        
        super.show();       
    }

    searchLiteralCategories(value: string){
        if(value !== undefined && value !== null) {
            let lowerSearch = value.toLowerCase();

            this.filteredLiteralCategory = this.allLiteralCategories.filter(r => {
                let lowerCaseName = r.Description.toLowerCase();
                return lowerCaseName.indexOf(lowerSearch) >= 0;
            });
        }
    }
    canGenerateReport(): boolean {
       let categoryCount = this.selectedLiteralCategory.length;
       if(categoryCount < 1){
           return false;
       }
       return true;
    }

    generateContent() {
        this.hideSpinner = false;
        const requestParams: ApiRequestDtoListLiteralCategory = { 
            OrgList: this.facilityService.selectedAsOrgList,
            _RequestOptions: this.selectedLiteralCategory
        };
        this.reportService.reportsGenerateResidentLiteralOrderReport(requestParams)
        .pipe(catchError((error) => {
            this.hideSpinner = true;
            throw new LoadingError(this.reportName, ErrorObjectTypeEnum.Report);
        }))
        .subscribe((result: Blob) => {
            this.downloadFile(result, "ResidentLiteralOrder.xls");
            this.hideSpinner = true;
            this.closeModal();
        });
    }

    selectLiteralCategory(event, literalCategory) {
         setTimeout(() => {         
                        
            if(!event.target.checked && this.areAllCategorySelected){ 
                this.selectedLiteralCategory = [];              
                this.filteredLiteralCategory.forEach(ns => ns.IsSelected = !ns.IsSelected);                               
                this.selectedLiteralCategory.push(literalCategory);
                this.areAllCategorySelected = false;                           
             }
             else if(event.target.checked){
                this.selectedLiteralCategory.push(literalCategory);
             }
             else{
                if(this.selectedLiteralCategory){                                      
                    let index = this.selectedLiteralCategory.findIndex(x=>x.Description == literalCategory.Description);
                    this.selectedLiteralCategory.splice(index,1);
                }
                
             }
         });
    }
   
    selectAllLiteralCategories(){
        this.selectedLiteralCategory = [];
        Object.assign(this.selectedLiteralCategory, this.filteredLiteralCategory);      
        this.filteredLiteralCategory.forEach(ns => ns.IsSelected = true);
        this.areAllCategorySelected = true;       
          
    }
    closeModal(){
        this.hideSpinner = true;
        this.searchText = '';
        this.recordsModal.hide();
        this.filteredLiteralCategory = [];
        this.allLiteralCategories = [];
        this.selectedLiteralCategory = [];
        this.areAllCategorySelected = true;
        this.ngOnDestroy();
    }
  
}